// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export class Player {
  constructor() {
    this.playbackNode = null;
    this.audioContext = null;
    this.onPlaybackFinished = null;
  }

  async init(sampleRate) {
    try {
      this.audioContext = new AudioContext({ sampleRate });
      await this.audioContext.audioWorklet.addModule("/js/playback-worklet.js");
  
      this.playbackNode = new AudioWorkletNode(this.audioContext, "playback-worklet");
      this.playbackNode.connect(this.audioContext.destination);
      
      // Set up the message handler for the playback finished event
      this.playbackNode.port.onmessage = (event) => {
        if (event.data === "playback_finished") {
          this.handlePlaybackFinished();
        }
      };
    } catch(ex) {
      console.log(ex);
    }
  }

  play(buffer) {
    if (this.playbackNode) {
      this.playbackNode.port.postMessage(buffer);
    }
  }

  clear() {
    if (this.playbackNode) {
      this.playbackNode.port.postMessage(null);
    }
  }

  handlePlaybackFinished() {
    if (this.onPlaybackFinished) {
      this.onPlaybackFinished();
    }
  }

  setOnPlaybackFinished(callback) {
    this.onPlaybackFinished = callback;
  }

  stop() {
    if (this.audioContext) {
      this.audioContext.close();
    }
    if (this.playbackNode) {
      this.playbackNode.disconnect();
    }
    this.audioContext = null;
    this.playbackNode = null;
  }
}